/**
 * A store for handling notifications - non persisting store
 */
const TYPE = Object.freeze({
  INFO: 'INFO',
  ERROR: 'ERROR',
});

const state = {
  data: [],
  id: 0,
};

const getters = {
  /**
   * Return all the notifications
   */
  getNotifications(state) {
    return state.data;
  },

  /**
   * Return the notification with the specified id
   * @param {Number}  id  The id of the notification we are searching
   */
  getNotification(state) {
    return id => {
      const index = state.data.findIndex(
        notification => notification.id === id
      );
      return index === -1 ? null : state.data[index];
    };
  },
};

const actions = {
  /**
   * Create a new information notification at the end of the notifications list
   * @param {String}  text  The notification message
   * @param {Number}  delay The delay (in ms)
   */
  createInfo(context, { text, delay = 3000 } = {}) {
    context.commit('create', { text, delay, type: TYPE.INFO });
  },

  /**
   * Create a new error notification at the end of the notifications list
   * @param {String}  text  The notification message
   * @param {Number}  delay The delay (in ms)
   */
  createError(context, { text, delay = 5000 } = {}) {
    context.commit('create', { text, delay, type: TYPE.ERROR });
  },

  /**
   * Remove a notification with the specified id from the list
   * @param {Number}  id    The notification id
   */
  delete(context, { id }) {
    context.commit('delete', { id });
  },
};

const mutations = {
  /**
   * Create a new notification (also gives it a new id).
   * @param {String}      text  The notification message
   * @param {Number}      delay The notification delay
   * @param {INFO|ERROR}  type  The notification type
   */
  create(state, { text, delay, type }) {
    state.id += 1;
    state.data.push({ text, delay, type, id: state.id });
  },

  /**
   * Remove a notification from the list
   * @param {Number} id   The notification id
   */
  delete(state, { id }) {
    const index = state.data.findIndex(notification => notification.id === id);
    if (index !== -1) {
      state.data.splice(index, 1);
    }
  },
};

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default module;
